function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1058 1C13.1764 1 12.4231 1.74619 12.4231 2.66667V4C12.4231 4.55186 12.6939 5.04107 13.111 5.3444C7.31501 6.69337 3 11.8476 3 18C3 25.1797 8.87626 31 16.125 31C23.3737 31 29.25 25.1797 29.25 18C29.25 11.8476 24.935 6.69337 19.139 5.3444C19.5561 5.04108 19.8269 4.55186 19.8269 4V2.66667C19.8269 1.74619 19.0736 1 18.1442 1H14.1058ZM14.4423 18.6667V8.47648C9.85409 9.26627 6.36538 13.2296 6.36538 18C6.36538 23.3388 10.7349 27.6667 16.125 27.6667C21.5151 27.6667 25.8846 23.3388 25.8846 18C25.8846 13.2296 22.3959 9.26625 17.8077 8.47648V18.6667C17.8077 19.5871 17.0543 20.3333 16.125 20.3333C15.1957 20.3333 14.4423 19.5871 14.4423 18.6667Z",
  fill: "black"
});

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.05a83fcd.svg";
export { ForwardRef as ReactComponent };